import { generateClient, post } from "aws-amplify/api";

const client = generateClient();

export async function requestListPackage(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_LIST_PACKAGE" });

    let items = [];
    let nextToken = "start";

    while (nextToken) {
      const params = {
        limit: 20,
        filter: { available: { eq: true }, offeredInIAP: { eq: false } },
      };
      if (nextToken && nextToken !== "start") {
        params.nextToken = nextToken;
      }
      const res = await client.graphql({
        query: listPackages,
        variables: params,
      });
      items = [...items, ...res.data.listPackages.items];
      nextToken = res.data.listPackages.nextToken;
    }

    items = items.sort((a, b) => a.title - b.title);

    dispatch({ type: "LIST_PACKAGE_SUCCESS", payload: { items } });
  } catch (error) {
    dispatch({ type: "LIST_PACKAGE_ERROR", error });
  }
}

export async function requestListUserSubscription(dispatch, payload) {
  try {
    const { page, userID, limit, nextToken = null } = payload;

    if (page > 1) {
      dispatch({
        type: "REQUEST_LIST_NEXT_USER_SUBSCRIPTION",
      });
    } else {
      dispatch({
        type: "REQUEST_LIST_USER_SUBSCRIPTION",
        payload: { page },
      });
    }

    const params = {
      userID,
      limit,
      sortDirection: "DESC",
      expiredAt: { gt: new Date().toISOString() },
      nextToken,
    };

    const res = await client.graphql({
      query: subscriptionsByUserExpiredAt,
      variables: params,
    });

    let { items, nextToken: token } = res.data.subscriptionsByUserExpiredAt;
    const nextPage = page + 1;

    dispatch({
      type: "LIST_USER_SUBSCRIPTION_SUCCESS",
      payload: { items, nextToken: token, nextPage, append: page > 1 },
    });
  } catch (error) {
    dispatch({ type: "LIST_USER_SUBSCRIPTION_ERROR", error });
  }
}

export async function requestUnsubscribeNewsletter(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_UNSUBSCRIBE_NEWSLETTER" });
    const { id } = payload;
    const request = post({
      apiName: "marketing",
      path: "/unsubscribe",
      options: {
        body: { id },
      },
    });

    const { body } = await request.response;

    const result = await body.json();

    dispatch({
      type: "UNSUBSCRIBE_NEWSLETTER_SUCCESS",
      payload: { unsubscribeStatus: result.message },
    });
  } catch (error) {
    dispatch({ type: "UNSUBSCRIBE_NEWSLETTER_ERROR", error });
  }
}

const listPackages = /* GraphQL */ `
  query ListPackages(
    $filter: ModelPackageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPackages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        icon
        features
        type
        membershipType
        period
        periodType
        price
        callBalance
        voucherType
        limit
        total
        available
        offeredInIAP
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const subscriptionsByUserExpiredAt = /* GraphQL */ `
  query SubscriptionsByUserExpiredAt(
    $userID: ID
    $expiredAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPackageSubscriptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subscriptionsByUserExpiredAt(
      userID: $userID
      expiredAt: $expiredAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        packageID
        userID
        voucher {
          id
          title
          description
          category
          type
          total
          limit
          expiredAt
          createdAt
          updatedAt
        }
        totalAvailable
        expiredAt
        createdAt
        updatedAt
        user {
          id
          identityId
          name
          email
          phone
          callBalance
          membership
          createdAt
          updatedAt
        }
        package {
          id
          title
          description
          icon
          features
          type
          membershipType
          period
          periodType
          price
          callBalance
          voucherType
          limit
          total
          available
          offeredInIAP
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
